// extracted by mini-css-extract-plugin
module.exports = {"flex":"favourites_flex__3CphG","height":"favourites_height__1MaIg"};